<div class="d-flex gap-5">
  <div style="flex: 2">
    <div class="">
      <div class="">
        <div class="question_container">
          <div class="questions">
            <span class="question_number fw-medium">
              Q. {{ currentQuestionId + 1 }}/{{ questions.length }}
            </span>
          </div>
          <p class="question_number ps-4 py-2">
            {{ questions[currentQuestionId].question }}
          </p>
          <div
            class="ps-4 pb-2 imgPopup"
            *ngIf="questions[currentQuestionId].questionImage != null"
          >
            <img
              src="data:image/png;base64,{{
                questions[currentQuestionId].questionImage
              }}"
              style="width: 300px; height: 300px"
            />
          </div>
        </div>
        <div class="options">
          <app-quiz-item
            [question]="questions[currentQuestionId]"
            (answer)="
              onAnswer(
                currentQuestionId,
                questions[currentQuestionId].questionId,
                $event
              )
            "
            [checkedIndex]="answers[currentQuestionId]"
          >
          </app-quiz-item>
        </div>
      </div>
    </div>
    <div class="d-flex gap-3 justify-content-end mt-5">
      <div *ngIf="currentQuestionId != 0" (click)="prev()"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
    >
        <img
        src="../../../assets/img/training_module/Button Arrow Left white.svg"
        width="18px"
        height="18px"
        alt="Next"
      />
      <span class="reload_text text-white">Previous</span>
    </div>
      
      <div *ngIf="currentQuestionId !== questions.length - 1" (click)="next()"
      class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
    >
        <img
        src="../../../assets/img/training_module/Button Arrow Right White.svg"
        width="18px"
        height="18px"
        alt="Next"
      />
      <span class="reload_text text-white">Next</span>
    </div>
        <div *ngIf="currentQuestionId === questions.length - 1" (click)="submitAllAnswers()"
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center">
         
        <span class="reload_text text-white"> Submit Answer</span>
      </div>
    </div>
  </div>
  <div class="options_panel">
    <div class="d-flex justify-content-between">
      <div>
        <div class="d-flex align-items-center gap-1">
          <div class="common_option selected"></div>
          <span class="option_text">Selected</span>
        </div>
        <div class="d-flex align-items-center gap-1 mt-2">
          <div class="common_option not_visited"></div>
          <span class="option_text">Not Visited</span>
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center gap-1">
          <div class="common_option answered"></div>
          <span class="option_text">Answered</span>
        </div>
        <div class="d-flex align-items-center gap-1 mt-2">
          <div class="common_option not_answered"></div>
          <span class="option_text">Not Answered</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 d-flex justify-content-between question_row" *ngFor="let question of questions;let i=index">
        <div class="outer_box selected_outer " *ngIf="currentQuestionId == i">
          <div class="inner_box selected_inner">
            <span class="que_number">{{i+1}}</span>
          </div>
        </div>
        <div class="outer_box answered_outer " *ngIf="currentQuestionId != i && question.answered">
          <div class="inner_box answered_inner">
            <span class="que_number">{{i+1}}</span>
          </div>
        </div>
        <div class="outer_box not_answered_outer " *ngIf="currentQuestionId != i && !question.answered && !question.notVisited">
          <div class="inner_box not_answered_inner">
            <span class="que_number">{{i+1}}</span>
          </div>
        </div>
        <div class="outer_box not_visited_outer" *ngIf="currentQuestionId != i && question.notVisited">
          <div class="inner_box not_visited_inner">
            <span class="que_number not_visited_que">{{i+1}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
